// @ts-nocheck
import CustomerZoneQuoteDetail from '@/PageComponents/CustomerZone/CustomerZoneQuote/CustomerZoneQuoteDetail';
import { createFileRoute } from '@tanstack/react-router';

export default CustomerZoneQuoteDetail;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/viewquote')({ component: CustomerZoneQuoteDetail });
